import i18n from "../../../../../i18n"
import Tables from 'src/class/Tables';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'symbol',
      label: i18n.t('common_words.symbol'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'description',
      label: i18n.t('common_words.description'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'assimilable_form',
      label: i18n.t('climate.assimilable_form'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    }
  ];

  return { Table };
};

export default configTable;
